import { OutlineElement } from '../../../base/outline-element/outline-element';
import { CSSResultGroup, html, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './ghs-jump-here.css.lit';

/**
 * Jump Here component (Used to set items for jump-navigation component)
 *
 * @element ghs-jump-here
 */
@customElement('ghs-jump-here')
export class GhsJumpHere extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * The label of the Jump Here item.
   */
  @property({ type: String, reflect: true })
  label = '';

  /**
   * The desired id of the Jump Here item (if not unique, a delta will be added to it).
   */
  @property({ type: String, reflect: false, attribute: 'item-id' })
  itemId = '';

  /**
   * The unique id of the Jump Here item.
   */
  @property({ type: String, reflect: true, attribute: 'id' })
  id = '';

  firstUpdated() {
    super.firstUpdated();
    if (this.itemId) {
      this.id = this.itemId;
    } else {
      this.id = this.label.toLowerCase().replace(/\W/gi, `-`);
    }
    // @ts-expect-error Property 'jumpHere' does not exist on type 'Window'.
    window.jumpHere = window.jumpHere ?? {};
    const baseId = this.id;
    let delta = 1;
    // @ts-expect-error Property 'jumpHere' does not exist on type 'Window'.
    while (window.jumpHere[this.id]) {
      this.id = `${baseId}-${delta}`;
      delta += 1;
    }
    // @ts-expect-error Property 'jumpHere' does not exist on type 'Window'.
    window.jumpHere[this.id] = true;

    if (this.label && this.id) {
      const jumpHereEvent = new CustomEvent('jump-here', {
        detail: {
          label: this.label,
          id: this.id,
        },
      });
      window.dispatchEvent(jumpHereEvent);
    }
  }

  /**
   * Back to top selector element. If true, provide the attribute for the
   * selector you want to use eg 'body' or 'ghs-jump-navigation'
   */
  @property({ attribute: 'back-to-top-selector' })
  backToTopSelector = '';

  scrollTo = () => {
    if (this.backToTopSelector) {
      document.querySelector(this.backToTopSelector)?.scrollIntoView();
    }
  };

  render(): TemplateResult {
    return html`
      <a class="jump-here" id="${this.id}" href="#${this.id}">${this.label}</a>
      ${this.backToTopSelector
        ? html`
            <a class="back-to-top" @click=${this.scrollTo}>
              Back to top

              <ghs-icon
                name="chevron-circle-up"
                size="30px"
                mobile-size="26px"
                site=${this.site}
              ></ghs-icon>
            </a>
          `
        : nothing}
    `;
  }
}
